import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import Paper from '~/components/Paper';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import PaperButtons from './PaperButtons';
import sortArray from '~/utils/sortArray';
import Request from '~/providers/Request';
import ModalCategory from './ModalCategory';
import ModalFolder from './ModalFolder';
import ModalArticle from './ModalArticleOld';
import Icon from '@material-ui/core/Icon';
import Edit from '@material-ui/icons/Edit';

import useStyles from './styles';
import ButtonMaterial from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { folders } from '~/config/routes';
import { Box, FormControl, MenuItem, Select } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';
import { URL } from '~/config/uri';
function Home() {
  const [categories, setCategories] = useState([]);
  const [openDropDown, setOpenDropDown] = useState(null);
  const [modalCategory, setModalCategory] = useState(false);
  const [modalFolder, setModalFolder] = useState(false);
  const [modalArticle, setModalArticle] = useState(false);
  const [category, setCategory] = useState({});
  const [folder, setFolder] = useState({});
  const [article] = useState({});
  const { t } = useTranslation();
  const classes = useStyles();
  const [selectedLanguage, setSelectedLanguage] = useState('1');

  useEffect(() => {
    async function fetchData() {
      const response = await fetch(
        `${URL}/admin/faqs?language_id=${selectedLanguage}`,
        {
          method: 'GET',
          headers: { Authorization: `Bearer ${await Request.getAuth()}` },
        },
        { normalizeJSON: false }
      );
      const data = await response.json();
      setCategories(data.data);
    }
    fetchData();
  }, [category, modalFolder, modalCategory, modalArticle, selectedLanguage]);

  return (
    <Paper
      Icon={QuestionAnswerIcon}
      iconColor="blue"
      title={t('menu-faq')}
      actions={
        <Box
          sx={{
            display: 'flex',
            direction: 'row',
            justifyContent: 'space-between',
            width: '18%',
          }}
        >
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <Select
              // labelId="idioma-label"

              variant="outlined"
              id="idioma"
              value={selectedLanguage}
              // fullWidth
              sx={{}}
              onChange={(e) => {
                setSelectedLanguage(e.target.value);
              }}
              IconComponent={ArrowDropDown}
            >
              <MenuItem value={'1'}>Português</MenuItem>
              <MenuItem value={'2'}>English</MenuItem>
              <MenuItem value={'3'}>Españhol</MenuItem>
            </Select>
          </FormControl>
          <PaperButtons
            setOpenDropDown={setOpenDropDown}
            openDropDown={openDropDown}
            setModalCategory={setModalCategory}
            setModalFolder={setModalFolder}
            setModalArticle={setModalArticle}
          />
        </Box>
      }
    >
      <hr />
      {categories.length !== 0 && (
        <GridContainer style={{ margin: 0 }}>
          {sortArray(categories, 'desc', 'sorter').map((cat) => (
            <GridItem xs={4} key={cat.id}>
              <GridContainer style={{ margin: 0 }}>
                <Icon style={{ color: 'lightgray' }}>forum</Icon>
                <ButtonMaterial
                  onClick={() => {
                    setCategory(cat);
                    setModalCategory(true);
                  }}
                >
                  {cat.name}
                </ButtonMaterial>
              </GridContainer>
              <ul>
                {sortArray(cat.folders, 'desc', 'sorter').map((fold) => (
                  <li key={fold.id} style={{ color: 'blue' }}>
                    <GridContainer>
                      <GridItem xs={12} md={8}>
                        <Link
                          to={folders.reverse({ id: fold.id })}
                          style={{ textDecoration: 'inherit' }}
                        >
                          <ButtonMaterial className={classes.button}>
                            {fold.name} ({fold.articles_count})
                          </ButtonMaterial>
                        </Link>
                      </GridItem>
                      <GridItem xs={12} md={4}>
                        <IconButton
                          className={classes.edit}
                          onClick={() => {
                            setFolder({ ...fold, category: cat.id });
                            setModalFolder(true);
                          }}
                        >
                          <Edit style={{ alignSelf: 'flex-end' }} />
                        </IconButton>
                      </GridItem>
                    </GridContainer>
                  </li>
                ))}
              </ul>
            </GridItem>
          ))}
        </GridContainer>
      )}
      <div>
        <ModalCategory
          modal={modalCategory}
          category={category}
          selectedLanguage={selectedLanguage}
          isEdit={category.id ? true : false}
          onClose={() => {
            setModalCategory(false);
            setCategory({});
            setOpenDropDown(null);
          }}
        />
        <ModalFolder
          modal={modalFolder}
          categories={categories}
          folder={folder}
          isEdit={folder.id ? true : false}
          onClose={() => {
            setModalFolder(false);
            setFolder({});
            setOpenDropDown(null);
          }}
        />
        <ModalArticle
          modal={modalArticle}
          folders_list={categories}
          article={article}
          isEdit={false}
          onClose={() => {
            setModalArticle(false);
            setOpenDropDown(null);
          }}
        />
      </div>
    </Paper>
  );
}

export default React.memo(Home);
